import { post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";

const API_PREFIX = "/evaluationConfirm";

export const getSelfEvaluation = async (req) => {
  const response = await post(`${API_PREFIX}/self`, req, authHeader());
  console.log("response", response);
  return response.data;
};

export const getOtherEvaluation = async (req) => {
  const response = await post(`${API_PREFIX}/other`, req, authHeader());
  console.log("response", response);
  return response.data;
};

export const getEvaluationDiff = async (req) => {
  const response = await post(`${API_PREFIX}/diff`, req, authHeader());
  console.log("response", response);
  return response.data;
};